export default {
    titulo: "Encuestas de satisfacción",
    columnaTitulo: "Titulo",
    nueva: "Nueva encuesta",
    eliminar: "Eliminar encuesta",
    pregEliminar: "¿Confirmas que deseas eliminar la encuesta?",
    verPreguntas: "Ver preguntas",
    aplicada: "Aplicada a ",
    opcionRep: "Órdenes de reparación",
    opcionServ: "Órdenes de servicio",
    repYserv: "Órdenes de reparación y servicio",
    aplicable: "La encuesta es aplicable a:",
    logo: "Logo",
    izquierda: "Izquierda",
    derecha: "Derecha",
    nuevaPregunta: "Nueva pregunta",
    preguntas: "Preguntas",
    preguntaNro: "Pregunta # ",
    msgIngresarPreg: "Ingresa al menos una pregunta para continuar",
    textoAyuda: "Texto de ayuda",
    tipo: "Tipo de pregunta",
    cuadroTexto: "Cuadro de texto donde contestará el cliente",
    opcion: "Opción",
    opciones: "Opciones",
    tipos: {
        texto: "Texto",
        radio: "Radio",
        check: "Check",
        lista: "Lista",
        escala: "Escala"
    },
    sub: "Subtítulo",
    eliminarPreg: "Eliminar pregunta",
    pregEliminarPreg: "¿Confirmas que deseas eliminar la pregunta?",
    EliminarOpcion: "Eliminar opción",
    pregEliminarOpcion: "¿Confirmas que deseas eliminar la opción?",
}